"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _parcelUtils = require("self-service-api/core/utilities/parcelUtils");

var _settingsApi = require("self-service-api/core/api/settingsApi");

var _PartnerProgramSelectors = require("pricing-pages-unified-ui/selectors/PartnerProgramSelectors");

var _SettingsSelectors = require("pricing-pages-unified-ui/selectors/SettingsSelectors");

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var BANNER_DISMISSED_KEY = 'partner-program:dismissed-banner';

var PartnerProgramBanner =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(PartnerProgramBanner, _Component);

  function PartnerProgramBanner(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PartnerProgramBanner);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PartnerProgramBanner).call(this, props));
    _this.state = {
      shouldShowBanner: false
    };
    _this.closeBanner = _this.closeBanner.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(PartnerProgramBanner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.isMounted_ = true;
      var _this$props = this.props,
          isPartnerProgramEligible = _this$props.isPartnerProgramEligible,
          isBannerDismissed = _this$props.isBannerDismissed;
      (0, _parcelUtils.isPaidHub)().then(function (hasPaidProduct) {
        if (!_this2.isMounted_) return;
        var shouldShowBanner = isPartnerProgramEligible && !hasPaidProduct && !isBannerDismissed;

        _this2.setState({
          shouldShowBanner: shouldShowBanner
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isMounted_ = false;
    }
  }, {
    key: "closeBanner",
    value: function closeBanner() {
      this.setState({
        shouldShowBanner: false
      });
      (0, _settingsApi.setSetting)(BANNER_DISMISSED_KEY, true);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      (0, _getUsageTracker.default)().track('externalLinkClick', {
        name: 'partner-banner-more-info'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var shouldShowBanner = this.state.shouldShowBanner;
      if (!shouldShowBanner) return null;
      return _react.default.createElement(_UIAlert.default, {
        type: "info",
        closeable: true,
        onClose: this.closeBanner,
        titleText: _react.default.createElement(_FormattedMessage.default, {
          message: "pricingPage.promotions.partnerProgram.title"
        })
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "pricingPage.promotions.partnerProgram.text",
        onClick: this.handleClick
      }));
    }
  }]);
  return PartnerProgramBanner;
}(_react.Component);

PartnerProgramBanner.propTypes = {
  isPartnerProgramEligible: _propTypes.default.bool.isRequired,
  isBannerDismissed: _propTypes.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isPartnerProgramEligible: (0, _PartnerProgramSelectors.isPartnerProgramEligibleSelector)(state),
    isBannerDismissed: (0, _SettingsSelectors.settingsValueSelector)(state, BANNER_DISMISSED_KEY)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(PartnerProgramBanner);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/banners/PartnerProgramBanner.js
// module id = 787
// module chunks = 5 6